<template>
  <div>
    <h1 class="mb-8">Exports</h1>
    <v-row>
      <v-col cols="12" md="6">
        <v-card>
          <v-card-title>Clients avec adresse e-mail</v-card-title>
          <v-card-text>
            Exporte au format excel tous les clients avec adresse e-mail d'un ou
            de plusieurs départements voulus. Renseignez les numéros dans le
            champ ci-dessous :
            <v-combobox
              v-model="departements"
              :items="items"
              class="mt-5"
              label="Saisissez un ou plusieurs numéros de département."
              multiple
              chips
            >
              <template v-slot:no-data>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>
                      Appuyez sur <kbd>entrer</kbd> pour ajouter le département.
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </template>
            </v-combobox>
          </v-card-text>
          <v-card-actions
            ><v-btn rounded dark color="pink" @click="exportAvecEmails"
              >Exporter</v-btn
            ></v-card-actions
          >
        </v-card>
      </v-col>
      <v-col cols="12" md="6"
        ><v-card>
          <v-card-title>Clients sans adresse e-mail</v-card-title>
          <v-card-text
            >Exporte au format excel tous les clients sans adresse e-mail
            renseignée, pour les départements voulus :
            <v-combobox
              v-model="departementsAdressePostale"
              :items="items"
              class="mt-5"
              label="Saisissez un ou plusieurs numéros de département."
              multiple
              chips
            >
              <template v-slot:no-data>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>
                      Appuyez sur <kbd>entrer</kbd> pour ajouter le département.
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </template>
            </v-combobox>
          </v-card-text>
          <v-card-actions
            ><v-btn rounded dark color="purple" @click="exportSansEmails"
              >Exporter</v-btn
            ></v-card-actions
          >
        </v-card></v-col
      >
      <v-col cols="12" md="6">
        <v-card
          ><v-card-title>Tous les clients</v-card-title
          ><v-card-text
            >Exporte l'ensemble de la base de données des clients.</v-card-text
          ><v-card-actions
            ><v-btn rounded dark color="green" @click="exportAllClients"
              >Exporter</v-btn
            ></v-card-actions
          ></v-card
        >
      </v-col>
    </v-row>
  </div>
</template>

<script>
import ExcelJs from "exceljs/dist/es5/exceljs.browser.js";
import { saveAs } from "file-saver";
export default {
  data() {
    return {
      departements: [],
      departementsAdressePostale: [],
      items: [],
    };
  },
  computed: {
    clients() {
      return this.$store.state.clients;
    },
    clientsAvecCodePostal() {
      return this.clients.filter(
        (c) => c.codePostal != "" && c.codePostal != null
      );
    },
  },
  methods: {
    async exportAllClients() {
      const clients = this.clients;
      clients.sort((a, b) => {
        const nomA = a.nom.toUpperCase();
        const nomB = b.nom.toUpperCase();
        if (nomA < nomB) {
          return -1;
        }
        if (nomA > nomB) {
          return 1;
        }
        return 0;
      });

      // Créer la feuille excel
      const fichier = new ExcelJs.Workbook();
      let curseur = 2;
      const feuilleClients = fichier.addWorksheet("Clients", {
        properties: { tabColor: { argb: "E0E0E0" } },
      });
      // On créé les colonnes
      feuilleClients.columns = [
        { header: "Nom", key: "nom", width: 20 },
        { header: "Prenom", key: "prenom", width: 20 },
        { header: "Email", key: "email", width: 33 },
        { header: "Adresse 1", key: "adresse1", width: 33 },
        { header: "Adresse 2", key: "adresse2", width: 30 },
        { header: "Code Postal", key: "codePostal", width: 15 },
        { header: "Ville", key: "ville", width: 27 },
        { header: "Téléphone fixe", key: "telephoneFixe", width: 20 },
        { header: "Téléphone portable", key: "telephonePortable", width: 20 },
        { header: "Commentaires", key: "commentaires", width: 20 },
      ];
      clients.forEach((client) => {
        feuilleClients.getCell(curseur, 1).value = client.nom?.toUpperCase();
        feuilleClients.getCell(curseur, 2).value = client.prenom;
        feuilleClients.getCell(curseur, 3).value = client.email;
        feuilleClients.getCell(curseur, 4).value = client.adresse1;
        feuilleClients.getCell(curseur, 5).value = client.adresse2;
        feuilleClients.getCell(curseur, 6).value = client.codePostal
          ? Number(client.codePostal)
          : "";
        feuilleClients.getCell(curseur, 7).value = client.ville?.toUpperCase();
        feuilleClients.getCell(curseur, 8).value = client.telephoneFixe;
        feuilleClients.getCell(curseur, 9).value = client.telephonePortable;
        feuilleClients.getCell(curseur, 10).value = client.commentaire || "";
        curseur++;
      });
      // ****** Passer toutes les en-têtes en gras ***** //
      feuilleClients.getRow(1).font = {
        bold: true,
      };

      // creer le fichier
      const buf = await fichier.xlsx.writeBuffer();

      saveAs(new Blob([buf]), "clients.xlsx");
    },
    async exportAvecEmails() {
      if (this.departements.length === 0) return;
      let clientsSelectionnes = [];
      this.departements.forEach((dep) => {
        this.clientsAvecCodePostal.forEach((client) => {
          if (
            client.codePostal.toString().substring(0, 2) == dep &&
            client.email
          ) {
            clientsSelectionnes.push(client);
          }
        });
      });

      // Créer la feuille excel
      const fichier = new ExcelJs.Workbook();
      let curseur = 2;
      const feuilleClients = fichier.addWorksheet("Clients", {
        properties: { tabColor: { argb: "E0E0E0" } },
      });
      // Page Manipulations et origine
      feuilleClients.columns = [{ header: "Email", key: "email", width: 55 }];
      clientsSelectionnes.forEach((client) => {
        feuilleClients.getCell(curseur, 1).value = client.email;
        curseur++;
      });
      // ****** Passer toutes les en-têtes en gras ***** //
      feuilleClients.getRow(1).font = {
        bold: true,
      };

      // creer le fichier
      const buf = await fichier.csv.writeBuffer();

      saveAs(new Blob([buf]), "clients-avec-email.csv");
    },
    async exportSansEmails() {
      if (this.departementsAdressePostale.length === 0) return;
      let clientsSelectionnes = [];
      this.departementsAdressePostale.forEach((dep) => {
        this.clientsAvecCodePostal.forEach((client) => {
          if (
            client.codePostal.toString().substring(0, 2) == dep &&
            !client.email
          ) {
            clientsSelectionnes.push(client);
          }
        });
      });

      // Créer la feuille excel
      const fichier = new ExcelJs.Workbook();
      let curseur = 2;
      const feuilleClients = fichier.addWorksheet("Clients", {
        properties: { tabColor: { argb: "E0E0E0" } },
      });
      // Page Manipulations et origine
      feuilleClients.columns = [
        { header: "Nom", key: "nom", width: 25 },
        { header: "Prénom", key: "prenom", width: 25 },
        { header: "Adresse", key: "adresse1", width: 55 },
        { header: "Adresse (suite)", key: "adresse2", width: 55 },
        { header: "Code Postal", key: "codePostal", width: 20 },
        { header: "Ville", key: "ville", width: 35 },
      ];
      clientsSelectionnes.forEach((client) => {
        feuilleClients.getCell(curseur, 1).value = client.nom;
        feuilleClients.getCell(curseur, 2).value = client.prenom;
        feuilleClients.getCell(curseur, 3).value = client.adresse1;
        feuilleClients.getCell(curseur, 4).value = client.adresse2;
        feuilleClients.getCell(curseur, 5).value = client.codePostal;
        feuilleClients.getCell(curseur, 6).value = client.ville;
        curseur++;
      });
      // ****** Passer toutes les en-têtes en gras ***** //
      feuilleClients.getRow(1).font = {
        bold: true,
      };

      // creer le fichier
      const buf = await fichier.csv.writeBuffer();

      saveAs(new Blob([buf]), "clients-sans-email.csv");
    },
  },
};
</script>
